<template>
    <editor-field-frame :label="props.label" :hint="props.hint" :control-id="controlId">
        <template #default="{controlId: id, hintId}">
            <!--
                Zugeklappt mit Vorschau (HTML als Text), aufgeklappt der
                bisherige TipTap-Editor. Die controlId verbindet das Label mit
                der Vorschau; TipTap selbst lässt sich nicht per Label ansprechen.
            -->
            <collapsible-text :text="value"
                              html
                              :label="props.label"
                              :control-id="id"
                              :described-by="hintId">
                <div class="basic-typography">
                    <tip-tap v-model="value" />
                </div>
            </collapsible-text>
        </template>
    </editor-field-frame>
</template>

<script setup>
import {computed} from "vue";
import EditorFieldFrame from "./EditorFieldFrame.vue";
import CollapsibleText from "./CollapsibleText.vue";
import TipTap from "../TipTap";
import {mandatory_props, useEditorField, editorControlId} from "../../utils/editorConfigFieldHelpers";

const props = defineProps(mandatory_props);
const {value, jsonPath} = useEditorField(props);

const controlId = computed(() => editorControlId('richtext', jsonPath.value));
</script>
